export enum StorageKey {
  API_KEY = 'api-key',
  CLIENT = 'client',
  ENDPOINT = 'endpoint',
  NOTIFICATION_ACTIVE = 'notification-active',
  OAUTH_TOKEN = 'oauth-token',
  PARAMETERS = 'parameters',
  USERNAME = 'username',
  SESSION = 'session',
  SEQUENCE = 'sequence',
};